/**
 * MessageBubble - Chat message component with user/AI variants
 * User messages: Neo style with Matrix green border
 * AI messages: Terminal style with left border accent
 */
import { Card, Text } from 'tamagui';

export type MessageRole = 'user' | 'assistant';

interface MessageBubbleProps {
  role: MessageRole;
  content: string;
  timestamp?: string;
}

export function MessageBubble({ role, content, timestamp }: MessageBubbleProps) {
  const isUser = role === 'user';

  return (
    <Card
      width="100%"
      maxWidth="70%"
      minWidth={280}
      ml={isUser ? 'auto' : undefined}
      mr={isUser ? undefined : 'auto'}
      backgroundColor={isUser ? '$backgroundHover' : '$backgroundPress'}
      borderWidth={isUser ? 1 : 0}
      borderColor={isUser ? '$green10' : undefined}
      borderLeftWidth={isUser ? 1 : 3}
      borderLeftColor="$green10"
      padding="$3"
      borderRadius="$3"
      borderTopRightRadius={isUser ? '$1' : '$3'}
      borderTopLeftRadius={isUser ? '$3' : '$1'}
      gap="$2"
      $sm={{
        maxWidth: '90%',
        minWidth: 240,
      }}
    >
      {!isUser && (
        <Text
          fontSize="$1"
          color="$green9"
          fontFamily="$mono"
          textTransform="uppercase"
        >
          AI Response:
        </Text>
      )}
      <Text
        fontFamily="$body"
        fontSize="$3"
        color="$color"
        lineHeight="$4"
      >
        {content}
      </Text>
      {timestamp && (
        <Text
          fontSize="$1"
          color="$placeholderColor"
          fontFamily="$mono"
          textAlign={isUser ? 'right' : 'left'}
        >
          {timestamp}
        </Text>
      )}
    </Card>
  );
}
